import React, { useState } from 'react';
import KnowledgeBasesList from './KnowledgeBasesList';
import KnowledgeBaseForm from './KnowledgeBaseForm';
import RoadmapsList from './RoadmapsList';
import RoadmapForm from './RoadmapForm';
import YogaPosesList from './YogaPosesList';
import YogaPoseForm from './YogaPoseForm';
import UsersList from './UsersList';

function Dashboard({ onLogout }) {
  const [view, setView] = useState(() => localStorage.getItem('adminView') || 'roadmaps');
  const [subView, setSubView] = useState('list'); // 'list' or 'form'
  const [editingItem, setEditingItem] = useState(null);

  const handleAdd = () => {
    setEditingItem(null);
    setSubView('form');
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setSubView('form');
  };

  const handleBack = () => {
    setEditingItem(null);
    setSubView('list');
  };

  const switchView = (newView) => {
    localStorage.setItem('adminView', newView);
    setView(newView);
    setSubView('list');
    setEditingItem(null);
  };


  return (
    <div className="dashboard">
      <div className="sidebar">
        <h2>Admin Panel</h2>
        <nav>
          <a
            href="#roadmaps"
            className={view === 'roadmaps' ? 'active' : ''}
            onClick={(e) => {
              e.preventDefault();
              switchView('roadmaps');
            }}
          >
            Roadmaps
          </a>
          <a
            href="#conversations"
            className={view === 'knowledgeBases' ? 'active' : ''}
            onClick={(e) => {
              e.preventDefault();
              switchView('knowledgeBases');
            }}
          >
            Knowledge Base
          </a>
          <a
            href="#yoga"
            className={view === 'yoga' ? 'active' : ''}
            onClick={(e) => {
              e.preventDefault();
              switchView('yoga');
            }}
          >
            Yoga Poses
          </a>
          <a
            href="#users"
            className={view === 'users' ? 'active' : ''}
            onClick={(e) => {
              e.preventDefault();
              switchView('users');
            }}
          >
            Registered Users
          </a>
        </nav>
      </div>
      <div className="main-content">
        <div className="header">
          <h1>AskNehru Content Management</h1>
          <button
            onClick={onLogout}
            className="px-3 py-1 text-sm bg-red-100 text-red-700 rounded hover:bg-red-200 border border-red-300"
          >
            Logout
          </button>
        </div>

        {view === 'knowledgeBases' && subView === 'list' && (
          <KnowledgeBasesList onNew={handleAdd} onEdit={handleEdit} />
        )}
        {view === 'knowledgeBases' && subView === 'form' && (
          <KnowledgeBaseForm
            conversationId={editingItem}
            onBack={handleBack}
            onSuccess={handleBack}
          />
        )}

        {view === 'roadmaps' && subView === 'list' && (
          <RoadmapsList onNew={handleAdd} onEdit={handleEdit} />
        )}
        {view === 'roadmaps' && subView === 'form' && (
          <RoadmapForm
            roadmapId={editingItem}
            onBack={handleBack}
            onSuccess={handleBack}
          />
        )}

        {view === 'yoga' && subView === 'list' && (
          <>
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-2xl font-bold">Yoga Poses Management</h2>
              <button
                onClick={handleAdd}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Add New Pose
              </button>
            </div>
            <YogaPosesList onEdit={handleEdit} />
          </>
        )}
        {view === 'yoga' && subView === 'form' && (
          <YogaPoseForm
            pose={editingItem}
            onClose={handleBack}
            onSuccess={handleBack}
          />
        )}

        {view === 'users' && (
          <UsersList />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
